import { render, staticRenderFns } from "./Renew-Warranty.vue?vue&type=template&id=5bb94a05&scoped=true"
import script from "./Renew-Warranty.vue?vue&type=script&lang=js"
export * from "./Renew-Warranty.vue?vue&type=script&lang=js"
import style0 from "./Renew-Warranty.vue?vue&type=style&index=0&id=5bb94a05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb94a05",
  null
  
)

export default component.exports